
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sectors/[slug]",
      function () {
        return require("private-next-pages/sectors/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sectors/[slug]"])
      });
    }
  